import React,{ useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, FormGroup, Col, Label, Table, Button} from 'reactstrap';
import TimePicker from 'rc-time-picker';
import { FaHourglassHalf } from "react-icons/fa";
import { Icon } from 'semantic-ui-react';
import moment from 'moment';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import { SaveAttachmentToFolder, 
         DeleteAttachment, 
         SavePreventativeMaintenanceTemplate, 
         OpenAddTemplatePopup, 
         GetPreventativeMaintenanceTemplateDetails, 
         actionToStoreSuccess, 
         DownloadAttachment, 
         AddPreventativeMaintenanceTemplateAttachment,
         DeletePreventativeMaintenanceTemplateAttachment,
         UpdatePreventativeMaintenanceTemplate } from '../../../../action/workorderAction'; 
import { setAmplitudeEvent } from 'amplitude/amplitude';

export default function CreatePMTemplate({Premise, TemplateId, Equipment, Page}){
    var Attachment_Table = "", EstimateTime = [], Description = [], PartsAndTools = [],  TaskList = [], errormsg, headingLabel='';
    let error_record = null,i;
    var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label>
    var timePickerElement = document.getElementById("EstimateTime");

    /*state declarations */
    const [displayImageError,setDisplayImageError] = useState(false);
    const [errorImageName, setErrorImageName] = useState(null);
    const [errorImageText, setErrorImageText] = useState(" file type not supported");
    const [image_Array, setImage_Array] = useState([]);
    const [nameError, setNameError] = useState(false);
    const [estimateError, setEstimateError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [partsError, setPartsError] = useState(false);
    const [taskError, setTaskError] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isCreateClicked, setIsCreateClicked] = useState(false);
    const [templateName, setTemplateName] = useState("");
    const [templateEstTm, setTemplateEstTm] = useState('');
    const [templateDesc, setTemplateDesc] = useState('');
    const [templatePartsTool, setTemplatePartsTool] = useState('');
    const [templateTasks, setTemplateTasks] = useState([]);
    const [duplicateNameError, setDuplicateNameError] = useState(false);
    const [invalidNameError, setInvalidNameError] = useState(false);
    const [invalidDescriptionError, setInvalidDescriptionError] = useState(false);
    const [taskCount, setTaskCount] = useState(1);
    const [initialMount, setInitialMount] = useState(true);
    

    /*ref declaration*/
    const nameRef = useRef();
    const descriptionRef = useRef();
    const partRef = useRef();
    const taskRef = useRef();
    const estimateRef = useRef();

    /*map state to props*/
    const label = useSelector(state => state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference);
    const PMPreferences = useSelector(state => state.authService.preventative_maintenance_user_preferencedetails);
    const AttachmentName = useSelector(state => state.WorkorderRootReducer.UniqueAttachmentName);
    const TemplateDetails = useSelector(state => state.WorkorderRootReducer.PreventativeMaintenanceTemplateDetails);
    const TemplateNames = useSelector(state => state.WorkorderRootReducer.PreventativeMaintenanceTemplates);

    /*map dispatch to props*/
    const dispatch = useDispatch();
    
    useEffect(() => {
        if(isCreateClicked){
            saveDatatoAPI();
        }
    },[isCreateClicked]);

    useEffect(() => {
        /*Scroll to top of the page*/
        var scrollPageTop = Premise ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
           Premise ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
        // Fetch the saved template details
        if(TemplateId !== -1){
            dispatch(GetPreventativeMaintenanceTemplateDetails(TemplateId));
         }
        return() =>{ /*component will unmount*/
            dispatch(OpenAddTemplatePopup(false,-1));
            dispatch(actionToStoreSuccess(undefined,"GET_PM_TEMPLATE_DETAILS"));
        }
    },[])

    useEffect(() => {
        if (AttachmentName !== null && AttachmentName !== []) {
            const newList = image_Array.map((item) => {
                if (item.Id === AttachmentName.Id) {
                    const updatedItem = { ...item, FileName: AttachmentName.FileName };
                    return updatedItem;
                }
                return item;
            });
            setImage_Array(newList);
        }
        if(TemplateId !== -1 && AttachmentName !== null && AttachmentName !== []){
            var fileName = image_Array.filter(e => e.Id === AttachmentName.Id) 
            if(fileName.length){
                var lineitem = {"Id": 0, "Name":fileName[0].Name, "FileName":AttachmentName.FileName}
                dispatch(AddPreventativeMaintenanceTemplateAttachment(lineitem, TemplateId));
            }
        }
    },[AttachmentName]);

    useEffect(() => {
        if(TemplateDetails !== undefined && initialMount){
            var dt = null,TaskList = [],attachmentList = [];
            var EstimatedTimeStr = TemplateDetails.estimatedTime !== "" && TemplateDetails.estimatedTime !== undefined ? TemplateDetails.estimatedTime.split(':') : "";
            if(EstimatedTimeStr !== ""){
                dt = moment(EstimatedTimeStr[0]+':'+EstimatedTimeStr[1],'HH:mm');
            }
            if(TemplateDetails.tasks !== undefined && TemplateDetails.tasks !== null && TemplateDetails.tasks.length){
                TaskList = TemplateDetails.tasks.map(el => ({
                      "Description" : el.taskDescription,
                      "isChecked" : el.isChecked,
                } 
                ));            
            }
            if(TemplateDetails.attachments !== null && TemplateDetails.attachments !== undefined && TemplateDetails.attachments.length){
                TemplateDetails.attachments.map(file => (
                    attachmentList.push({'Id': file.id, 'Name':file.name, 'FileName': file.fileName})
                ))
            }
            setTaskCount((TemplateId !== -1 && TaskList.length) ? TaskList.length : 1);
            setTemplateName(TemplateDetails.name);
            setTemplateEstTm(dt);
            setTemplateDesc(TemplateDetails.description);
            setTemplatePartsTool(TemplateDetails.partsTools);
            setTemplateTasks(TaskList);
            setImage_Array(attachmentList);
            setInitialMount(false);
        }
    },[TemplateDetails,initialMount])

    /*Style changes*/
    const headinglabel={
        fontfamily: 'Lato',
        fontSize: '14px',
        fontWeight: 'bold'
    };

    const ErrorSign = {
        color: '#D42D27',
        paddingLeft: '8px',
        paddingTop: '0px',
        paddingRight: '14px',
        width: '22px',
        height: '22px',
        top: '406px',
        left: '959px',
    };

    const ErrorPadding = {
        color: '#D42D27',
        fontfamily: 'Lato',
        fontStyle: 'italic',
        border: '2px solid #D42D27',
        height: '40px',
        padding: '10px',
        float: 'right',
    };
   
    i = taskCount;

    /*On key press*/ 
    const keyPressed = (event) => {
        var code = event.keyCode || event.which;
        if (code === 13){
            let value = event.target.value;
            if(value !== ''){
                //dynamically creating checkboxes
                var checkbox = document.createElement('input');
                checkbox.setAttribute('type', 'checkbox');
                checkbox.setAttribute('id','check'+i);
                checkbox.style.verticalAlign = "middle";

                //dynamically creating input 
                var input = document.createElement('input');
                input.setAttribute('type','text');
                input.setAttribute('id','task'+ i);
                input.style.backgroundColor = "rgb(244,244,244)";
                input.style.border = "none";
                input.style.verticalAlign = "middle";
                input.style.width = "95%";
                input.style.fontWeight = "bold";
                input.className = "text_field_css";
                input.setAttribute('autofocus','true');
                input.addEventListener('keyup', keyPressed);
             
                //dynamically creating span
                var span = document.createElement('span');
                span.setAttribute('contenteditable','false');
                span.appendChild(checkbox);

                //dynamically creating td,tr
                var td = document.createElement('td');
                td.className = "col-sm-12";
                td.style.padding = "0px";
                td.appendChild(span);
                td.appendChild(document.createTextNode( '\u00A0' ) );
                td.appendChild(input);

                var tr = document.createElement('tr');
                tr.appendChild(td);

                document.getElementById("taskid").appendChild(tr);
                document.getElementById('task'+ i).focus();
                var x = window.scrollX, y = window.scrollY;
                window.scrollTo(x,y);
                i++;
            }
        }
        if(event.keyCode === 8 && event.target.value === "" && event.target.nodeName === "INPUT"){
            var id = event.target.id;
            var num = id.split("task")[1];
            if(document.getElementById("taskid").childNodes.length > 1 ){
                var parentnode = document.getElementById('check'+ num).parentNode;
                var grandparentnode = parentnode.parentNode;
                var greatgrandparentnode = grandparentnode.parentNode;
                var previouselement = greatgrandparentnode.previousSibling;
                parentnode.removeChild(document.getElementById('check'+ num));
                grandparentnode.removeChild(parentnode);
                grandparentnode.removeChild(document.getElementById('task'+num));
                greatgrandparentnode.removeChild(grandparentnode);
                document.getElementById("taskid").removeChild(greatgrandparentnode);
                previouselement.childNodes[0].childNodes[2].focus();
            }
        }
    }

    /*On file change*/
    const handleAttachment = e => {
        e.preventDefault();

        setDisplayImageError(false);
        setErrorImageName(null);
        setErrorImageText(" file size limit exceeded.");
       
        var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];

        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(), //file extension from input file
            fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

            if (fileTypeSuccess && fileSize <= 25000000 ) {
                let reader = new FileReader();
                let file = e.target.files[0];
                reader.onloadend = () => {
                    var index_Array = image_Array.map(el => (
                        parseInt(el.Id)
                    ));
                    var maxid = image_Array.length === 0 ? 0 : Math.max(...index_Array);
                    setImage_Array([...image_Array,{'Id': maxid  + 1, 'Name':file.name, 'FileName': ''}]);
                    const data = new FormData();
                    data.append('file', file);
                    dispatch(SaveAttachmentToFolder(data, maxid  + 1));
                }
                reader.readAsDataURL(file)
                e.target.value = null;
            } else if(fileSize >= 25000000) { 
                setDisplayImageError(true);
                setErrorImageName(e.target.files[0].name);
                setErrorImageText(" file size limit exceeded.");
            } else  { 
                setDisplayImageError(true);
                setErrorImageName(e.target.files[0].name);
                setErrorImageText(" file type not supported.");
            }
        }
    }

    /*Download attachments*/
    const AttachmentDownload = (fileName) => {
        dispatch(DownloadAttachment(fileName));
    }

    /*Delete attachments*/
    const DeleteAttachments = (element,id) => {
        let lineitem = {
            "AttachmentId": (TemplateId !== -1) ? id : 0,
            "FileName": element,
        }
        if(TemplateId !== -1)
            dispatch(DeletePreventativeMaintenanceTemplateAttachment(TemplateId, id));
        dispatch(DeleteAttachment(lineitem));
        setImage_Array(image_Array.filter(el => el.FileName !== element));
    }

    /*Redirect to PM setup screen*/
    const handleCancel = () =>{
        dispatch(OpenAddTemplatePopup(false,-1))
    }

    /*Save PM Template*/
    const savePMTemplate = () =>{
        setIsCreateClicked(true);
        duplicateNameCheck(); 
        descriptionCheck();       
        nameRef.current.value.trim() !== "" ? setNameError(false) : setNameError(true);
        Description.length > 0 ? ((!Description[0].required || (Description[0].required && descriptionRef.current.value.trim() !== "")) ? setDescriptionError(false) : setDescriptionError(true)) : setDescriptionError(false);
        PartsAndTools.length > 0 ? ((!PartsAndTools[0].required || (PartsAndTools[0].required && partRef.current.value.trim() !== "")) ? setPartsError(false) : setPartsError(true)) : setPartsError(false);
        TaskList.length > 0 ? ((!TaskList[0].required || (TaskList[0].required && document.getElementById('task0').value !== "")) ? setTaskError(false) : setTaskError(true)) : setTaskError(false);
        EstimateTime.length > 0 ? ((!EstimateTime[0].required || (EstimateTime[0].required && estimateRef.current.picker.value !== "")) ? setEstimateError(false) : setEstimateError(true)) : setEstimateError(false);
    }

    const descriptionCheck = () => {
        var RegexRestrictDescSpecialCharacter = /^[^<>;]+$/;
        var lDescription = descriptionRef.current.value.trim();
        (lDescription !== "" && !lDescription.match(RegexRestrictDescSpecialCharacter)) ? setInvalidDescriptionError(true) : setInvalidDescriptionError(false);
    }

    /*Duplicate Name Validation*/
    const duplicateNameCheck = () => {       
        if(TemplateNames !== undefined && TemplateNames !== null && TemplateNames.length){
           var duplicate =  TemplateNames.filter(item =>(
                item.name.toLowerCase() === templateName.toLowerCase()
           ))
           
           if(duplicate.length){
               if(TemplateId !== -1 && duplicate[0].name.toLowerCase() === TemplateDetails.name.toLowerCase()){
                    setDuplicateNameError(false);
               }else{
                    setDuplicateNameError(true);
               }
           }else{
                setDuplicateNameError(false);
           }
        }
    }

    const saveDatatoAPI = () => {
       setIsCreateClicked(false);
       var Attachments = [], AttachmentItems = '', Tasks = [], TemplateCreatedPage;
       /*task list*/
       if(taskRef.current !== undefined){
           if(taskRef.current.childNodes.length > 0){
               let j=0, data=[], ischecked=[];
               let length = document.getElementById('taskid').childNodes.length;
               for(j=0;j<length;j++){
                   data.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[2].value);
                   ischecked.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[0].childNodes[0].checked);
               }
               for(j=0;j<length;j++){
                   if(data[j] !== ""){
                       var TaskItem = {
                           "TaskDescription" : data[j],
                           "IsChecked" : ischecked[j]
                       }
                       Tasks.push(TaskItem);
                   }
               }
           }
       }
        /*attachments*/
        if (image_Array.length) {
            image_Array.forEach(el => {
                 AttachmentItems = {
                     "Name": el.Name,
                     "FileName": el.FileName
                 }
                 Attachments.push(AttachmentItems);
             });
         }
        if(!nameError && !estimateError && !descriptionError && !partsError && !taskError && !duplicateNameError && !invalidNameError && !invalidDescriptionError){
            let lineitem = {
                "TemplateId": (TemplateId !== -1) ? TemplateId : 0,
                "Name": nameRef.current !== undefined ? nameRef.current.value : "",
                "EstimatedTime": estimateRef.current !== undefined ? (estimateRef.current.picker.value !== "" ? estimateRef.current.picker.value : '00:00') : '00:00',
                "Description": descriptionRef.current !== undefined ?  descriptionRef.current.value : "",
                "PartsTools": partRef.current !== undefined ? partRef.current.value : "",
                "Tasks": Tasks,
                "Attachments": (image_Array.length > 0 && TemplateId === -1) ? Attachments : null,
            }
            const l_Request = (TemplateId !== -1) ? dispatch(UpdatePreventativeMaintenanceTemplate(TemplateId, lineitem))  : dispatch(SavePreventativeMaintenanceTemplate(lineitem));
            l_Request.then(() => {
                /*Tag Amplitude Event*/
                if(TemplateId === -1){
                    TemplateCreatedPage = (Equipment) ? 'Equipment page' : Page;
                    setAmplitudeEvent('Create Preventative Maintenance Template',{'Page':TemplateCreatedPage});
                }
                setIsError(false);
                dispatch(OpenAddTemplatePopup(false,-1))
            });
        }else{
            setIsError(true);
        }
    }

    // inline validation for name field
    const updatePMName=(evt)=> {
        setTemplateName(evt.target.value);
        var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9_\-.,&()$:! ]*$/.test(evt.target.value);
        setInvalidNameError(!RegexRestrictSpecialCharacter);
     }

    /*Preferences from PM Standard Fields*/
    if(PMPreferences !== undefined && PMPreferences !== '')
    {
        EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time" && x.display === true);
        Description = PMPreferences.filter(x => x.field === "Description" && x.display === true);
        PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools" && x.display === true);
        TaskList = PMPreferences.filter(x => x.field === "Task List" && x.display === true);
    }

    error_record = <tr>
                        <td width="100%"><Icon name='exclamation triangle'style={{marginRight:'1px',padding:'0px',color:'#D42D27'}}/>{" An error has occurred. "}{errorImageName}{errorImageText}</td>
                        <td></td>
                    </tr>

    if (image_Array != null && image_Array.length > 0) {
        Attachment_Table = image_Array.map(el => (
            <tr>
                <td className={(TemplateId !== -1) ? "link_cursorUnderline" : "workorderlbl"} 
                    style={{ "width" : "90%", "word-wrap" : "break-word" }}
                    onClick={() => (TemplateId !== -1) ? AttachmentDownload(el.FileName): null}>
                        {el.Name}
                </td>                              
                <td width="10%">
                    <img src={DeleteIcon} alt="Delete" 
                        className="Ensemble_Icon link_cursor" 
                        style={{ valign: 'bottom',width:'15px', height:'14px' }} 
                        onClick={() =>  {DeleteAttachments(el.FileName,el.Id)} } /></td>
            </tr>
        ));
    }else{
        Attachment_Table = <tr><td className="workorderlbl-noentry">{"No attachments"}</td><td>{" "}</td></tr>
    }

    if(timePickerElement !== null){
        timePickerElement.className = (estimateError) ? "rc-time-picker-error" :  "rc-time-picker-input";
    }

    if (isError) {
        errormsg = <p style={ErrorPadding} >
            <Icon name='exclamation triangle' style={ErrorSign} />
            <b>Please correct all errors before continuing.</b>
        </p>
    }

    headingLabel = (TemplateId !== -1) ? 
                    label['EditPMTemplate.Heading.Text'] !== undefined ? label['EditPMTemplate.Heading.Text'] : "Edit Preventative Maintenance Template" 
                    : label['CreatePMTemplate.Heading.Text'] !== undefined ? label['CreatePMTemplate.Heading.Text'] : "Create New Preventative Maintenance Template"

    return(
        <div className="main_container">
            <Form>
            {/*Heading*/}
            <FormGroup row>
                <Col sm={{size:12}}>
                    <Label style={headinglabel}>{headingLabel}</Label>
                    {errormsg}
                </Col>
            </FormGroup>

            {/*Name Field*/}
                <FormGroup row>
                    <Col sm={{size: Equipment ? 10 : 6}}>
                        { 
                            Equipment ? 
                                <Label id="lblTemplateName" className={(nameError || duplicateNameError) ? "errortext workorderlbl" : "workorderlbl"}>
                                    {(label['PMUpcomingWork.Name.Text'] !== undefined) ? label['PMUpcomingWork.Name.Text'] + "*" : "Name*"}
                                </Label> : 
                                <Label id="lblTemplateName" className={(nameError || duplicateNameError) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                                    {(label['PMUpcomingWork.Name.Text'] !== undefined) ? label['PMUpcomingWork.Name.Text'] + "*" : "Name*"}
                                </Label>
                        }
                        <br/>
                        <input id="txtTemplateName" aria-label="name" ref={nameRef} type="text" 
                            style={{ width : (nameError || duplicateNameError) ? '95%' : '100%'}} 
                            className= {(nameError || duplicateNameError || invalidNameError) ? "errorhighlight pm_textbox" : "pm_textbox"} 
                            maxLength="50" 
                            value={templateName}
                            onChange={evt => updatePMName(evt)}/>
                        <span hidden={!nameError && !duplicateNameError && !invalidNameError}>
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}>
                                <b>{(duplicateNameError) ? "Duplicate Name": (invalidNameError) ? "Name can only contain letters, numbers, and the following characters _-.,&()$:!" : "An entry is required"}</b>

                            </Label>
                        </span>
                    </Col>
                </FormGroup>

            {/*Estimated Time*/}
            {
                EstimateTime.length > 0 ?
                <FormGroup row>
                     <Col sm={{size: Equipment ? 4 : 2}}>
                         {
                             Equipment ?
                                <Label id="lblTemplateEquipment" className={(estimateError) ? "errortext workorderlbl" : "workorderlbl"}>
                                    {(EstimateTime[0].required) ? EstimateTime[0].fieldLabel + "*" : EstimateTime[0].fieldLabel}
                                </Label> :
                                <Label id="lblTemplateEquipment" className={(estimateError) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                                    {(EstimateTime[0].required) ? EstimateTime[0].fieldLabel + "*" : EstimateTime[0].fieldLabel}
                                </Label>
                         }                       
                        <br/>
                        <label id="lblTemplateEstimateTime" style={{'cursor':'pointer', marginBottom:'0px'}} className={(estimateError) ? "errorhighlight" : ""}>
                            <TimePicker ref={estimateRef} id="EstimateTime" 
                                showSecond={false}
                                popupStyle={{zIndex: Equipment? 2147483646 : 1050}}
                                focusOnOpen 
                                style={{width:'100%'}} 
                                value={templateEstTm}
                                onChange={(evt) => setTemplateEstTm(evt)}/>
                            <div className="pm_timerdiv"> 
                                <FaHourglassHalf className="pm_calendarbox" width="17px" height="17px" />
                            </div>
                        </label>
                        <span hidden={!estimateError}>{selecterrortext}</span>
                    </Col>
                </FormGroup> : ""
            }

            {/*Description*/}
            {
                Description.length > 0 ?
                <FormGroup row>
                    <Col sm={{size: Equipment ? 10 : 6}}>
                        {
                            Equipment ? 
                                <Label id="lblTemplateDescription" className={(descriptionError) ? "errortext workorderlbl" : "workorderlbl"}>
                                    {(Description[0].required) ? Description[0].fieldLabel + "*" : Description[0].fieldLabel}
                                </Label> : 
                                <Label id="lblTemplateDescription" className={(descriptionError) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                                    {(Description[0].required) ? Description[0].fieldLabel + "*" : Description[0].fieldLabel}
                                </Label>
                        }
                        <br/>
                        <textarea ref={descriptionRef} id="txtareaTemplateDescription"
                            style={{ width : (descriptionError) ? '95%' : '100%', verticalAlign: 'text-bottom'}} 
                            className={(descriptionError || invalidDescriptionError) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"} 
                            maxLength="4000" 
                            value={templateDesc}
                            onChange={(evt) => setTemplateDesc(evt.target.value)}/>                        
                        <span hidden={!invalidDescriptionError}>
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}>
                                <b>{(invalidDescriptionError) ? "Enter valid input" : ""}</b>
                            </Label>
                        </span>
                        <span hidden={!descriptionError} style={{position:'relative',top:'-5px'}}>
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label>
                        </span>
                    </Col>
                </FormGroup> : ""
            }

            {/*Parts and Tools*/}
            {
                PartsAndTools.length > 0 ?
                <FormGroup row>
                    <Col sm={{size: Equipment ? 10 : 6}}>
                        {
                            Equipment ? 
                                <Label id="lblTemplateParts" className={(partsError) ? "errortext workorderlbl" : "workorderlbl"}>
                                    {(PartsAndTools[0].required) ? PartsAndTools[0].fieldLabel + "*" : PartsAndTools[0].fieldLabel}
                                </Label> : 
                                <Label id="lblTemplateParts" className={(partsError) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                                    {(PartsAndTools[0].required) ? PartsAndTools[0].fieldLabel + "*" : PartsAndTools[0].fieldLabel}
                                </Label>
                        }
                        <br/>
                        <textarea ref={partRef} id="txtareaTemplateParts"
                            style={{ width : (partsError) ? '95%' : '100%', verticalAlign: 'text-bottom'}} 
                            className={(partsError) ? "errorhighlight pm_box" : "pm_box"} 
                            maxLength="4000" 
                            value={templatePartsTool}
                            onChange={(evt) => setTemplatePartsTool(evt.target.value)}/>
                        <span hidden={!partsError} style={{position:'relative',top:'-5px'}}>
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label>
                        </span>
                    </Col>
                </FormGroup> : ""
            }

            {/*Task List*/}
            {
                TaskList.length > 0 ?
                <FormGroup row>
                     <Col sm={{size: Equipment ? 10 : 6}}>
                         {
                            Equipment ? 
                                <Label id="lblTemplateTasks" className={(taskError) ? "errortext workorderlbl" : "workorderlbl"}>
                                    {(TaskList[0].required) ? TaskList[0].fieldLabel + "*" : TaskList[0].fieldLabel}
                                </Label> :
                                <Label id="lblTemplateTasks" className={(taskError) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>
                                    {(TaskList[0].required) ? TaskList[0].fieldLabel + "*" : TaskList[0].fieldLabel}
                                </Label>
                         }
                        <br/>
                        <div ref={taskRef} id="tasklist" style={(taskError) ? {width:'95%',display:'inline-block',padding:'2px'} :{ width: '100%',display:'inline-block',padding:'2px'}} className={(taskError) ? "errorhighlight pm_tasklist": "pm_tasklist"}>
                            <table style={{width:'100%'}}>
                                <tbody id="taskid">
                                {(templateTasks !== null && templateTasks.length !== 0) ? templateTasks.map((el,index) =>(
                                     <tr>
                                        <td className="col-sm-12" style={{padding:'0px'}}>
                                            <span contentEditable="false">
                                                <input type="checkbox" id={"check"+ index}
                                                defaultChecked = {el.isChecked}    
                                                style={{'vertical-align':'middle'}}/>
                                            </span>&nbsp;
                                            <input type="text"  id={"task"+ index}
                                                style={{border:'none',backgroundColor:'rgb(244,244,244)','vertical-align':'middle',width:'95%',fontWeight:'bold'}} 
                                                onKeyUp={(e) => keyPressed(e)} 
                                                contentEditable="true" 
                                                defaultValue={el.Description}>
                                            </input>
                                        </td>
                                    </tr> )) :
                                    <tr>
                                        <td className="col-sm-12" style={{padding:'0px'}}>
                                            <span contenteditable="false">
                                                <input type="checkbox" id="check0" style={{'vertical-align':'middle'}}/>
                                            </span>&nbsp;
                                            <input type="text" id="task0" 
                                                style={{border:'none',backgroundColor:'rgb(244,244,244)','vertical-align':'middle',width:'95%',fontWeight:'bold'}} 
                                                autofocus="true" 
                                                contenteditable="true" 
                                                onKeyUp={(e) => keyPressed(e)} />
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </table>
                        </div>
                        <span hidden={!taskError} style={{position:'relative',top:'-5px'}}>
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label>
                        </span>
                    </Col>
                </FormGroup> : ""
            }
            

            {/*Attach Supporting Documents*/}
            <FormGroup row>
                <Col sm={{size: Equipment ? 10 : 6}}>
                    {
                        Equipment ? 
                            <Label className="workorderlbl" id="lblTemplateAttachments"> 
                                {label['WorkOrders.Heading.Attachments.Text']}
                            </Label> : 
                            <Label className="workorderlbl CreatePMlbl_margin" id="lblTemplateAttachments">
                                {label['WorkOrders.Heading.Attachments.Text']}
                            </Label>
                    }
                    <Label className="workorderedit-choosebtn" style={{float:'right'}}>
                        <input type="file" id="myfile" onChange={(e) => handleAttachment(e)}/>{label['WorkOrderEdit.ChooseFile.Text']}
                    </Label>
                    <br/>
                    <Table responsive className="attachmentTable">
                        <tbody>
                            <tr><th width="90%">ATTACHMENTS</th><th width="10%">{" "}</th></tr>
                                {Attachment_Table}  
                                {(displayImageError) ? error_record : null }
                        </tbody>
                    </Table>
                    <Label className="workorderlbl-noentry">{label['WorkOrderEdit.FileTypes.Text']}</Label>
                </Col>
            </FormGroup>

            {/*Buttons*/}
            <FormGroup row>
                <Col sm={{size:Equipment ? 10 : 6}} style={{textAlign:'right'}}>
                    <Label className="pm_template_cancel_label" id="btnTemplateCancel" onClick={() => handleCancel()}>{label['WorkOrders.CreateTenant.Cancel.Text'] !== undefined ? label['WorkOrders.CreateTenant.Cancel.Text'] : "Cancel"}</Label>
                    <Button className="pm_template_create_button" id="btnTemplateCreate" onClick={() => savePMTemplate()}>
                        {(TemplateId === -1) ? 
                            label['CreatePMTemplate.Button.Create.Text'] !== undefined ? label['CreatePMTemplate.Button.Create.Text'] : "Create"
                            : label['InoviceSetup.Save.Text'] !== undefined ? label['InoviceSetup.Save.Text'] : "Save"}
                    </Button>
                </Col>
            </FormGroup>
            </Form>
        </div>
    )
}